import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsNotificationsFuelStations = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/fuelStations/notifications${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  ADD: (id) => `/v1/fuelStations/notifications/${id}/user`,
  REMOVE: (id, userId) => `/v1/fuelStations/notifications/${id}/user/${userId}`,
}

export default endpointsNotificationsFuelStations
